module.exports = __webpack_public_path__ + "static/Gitlab-188c9dd790196cbd37405dc64fea9b6b.jpg";